// TODO: Own Audio Input will not get saved atm
export function isOwnAudioInputEnabled(_) {
    return true;
}
export function isOthersAudioInputEnabled(state) {
    return state['features/inklusiva/userdata'].audio?.otherParticipants;
}
export function isFilterBackgroundNoiseEnabled(state) {
    return state['features/inklusiva/userdata'].audio?.background;
}
export function getVolumeValue(state) {
    return state['features/inklusiva/userdata'].audio?.volume;
}
export function getHighFrequenciesValue(state) {
    return state['features/inklusiva/userdata'].audio?.highFreq;
}
export function getBalanceValue(state) {
    return state['features/inklusiva/userdata'].audio?.balance;
}
export function getAmplifyValue(state) {
    return state['features/inklusiva/userdata'].audio?.amplify;
}
export function getAudioCuesEnabled(state) {
    return state['features/inklusiva/userdata'].ui?.acousticCues;
}
export function getVisualCuesEnabled(state) {
    return state['features/inklusiva/userdata'].ui?.visualCues;
}
